import { connect } from 'react-redux';
import ObjectAbout from './ObjectAbout';
import { savePage } from '../../globalState/object/actions';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { WithObjectComponentHOC } from '../../HOC/WithObjectComponentHOC';
import { WithAppendHeaderAndFooterHOC } from '../../HOC/WithAppendHeaderAndFooterHOC';
import { WithAppendSidebarHOC } from '../../HOC/WithAppendSidebarHOC';
import { WithSavingSnackBar } from '../../HOC/WithSavingSnackBar';
import {
  getDescriptionSelector,
  getFloorTotalCountSelector,
  getFloorValueSelector,
} from './selectros';

let mapStateToProps = (state) => {
  return {
    headerSubtitle: true,
    description: getDescriptionSelector(state),
    floorValue: getFloorValueSelector(state),
    floorTotalCount: getFloorTotalCountSelector(state),
  };
};

let mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(
  connect(mapStateToProps, {
    mapDispatchToProps,
    savePage,
  }),
  withRouter,
  WithObjectComponentHOC,
  WithAppendHeaderAndFooterHOC,
  WithAppendSidebarHOC,
  WithSavingSnackBar
)(ObjectAbout);
